<template>
  <div
    :ref="`capture${uid}`"
    class="capture"
  >
    <div class="font-normal text-[#707C8E] px-6 py-5">
      <div class="flex justify-between mb-2">
        <h3 class="text-sm font-normal 2xl:text-md">
          {{ cardTitle }}
        </h3>
        <div class="flex">
          <button
            type="button"
            @click="downloadImage(cardTitle)"
          >
            <DownloadIcon />
          </button>
        </div>
      </div>
      <div
        v-if="dateRange?.start_date"
        class="my-3 2xl:text-base no-localize-translate"
      >
        <span>
          <span class="px-4 py-1.5 flex w-fit items-center gap-x-1 rounded-full text-sm bg-[#E9E9EE33]/20">
            <span>
              <DateRangeIcon />
            </span>
            <span> {{ $moment(dateRange.start_date).format('DD/MM/YYYY') }} &RightArrow;</span>
            <span>{{ $moment(dateRange.end_date).format('DD/MM/YYYY') }}</span>
          </span>
        </span>
      </div>

      <div
        v-if="showSide"
        class="flex items-center justify-between gap-x-8"
      >
        <div class="flex items-center h-16">
          <slot name="left" />
        </div>
        <slot name="right" />
      </div>
      <div>
        <slot name="graph" />
      </div>
    </div>
  </div>
</template>

<script>
import domtoimage from 'dom-to-image'

export default {
  name: 'GhgEmissionsChartCard',

  props: {
    cardTitle: {
      type: String,
      required: true,
    },
    dateRange: {
      type: Object,
      default: () => {},
    },
    showSide: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      uid: null,
    }
  },
  mounted() {
    this.uid = this.$.uid
  },
  methods: {
    downloadImage(title) {
      const captureElement = this.$refs['capture' + this.uid]

      if (!captureElement) return
      domtoimage
        .toPng(captureElement, { bgcolor: 'white' })
        .then(function (dataUrl) {
          const link = document.createElement('a')
          link.href = dataUrl
          link.download = title + '.png'
          link.click()
        })
        .catch((_) => {
          this.$toast.error(`Unable to download this ${title} summary`, {
            timeout: 5000,
            position: 'top-right',
          })
        })
    },
  },
}
</script>
